import { BlockStack as BlockStack$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const BlockStack = createRemoteReactComponent(BlockStack$1);

export { BlockStack };
